import { useContext } from "react";

import { DefaultTemplatesContext } from "./DefaultTemplatesContext";

export const useDefaultTemplates = () => useContext(DefaultTemplatesContext);
